import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { HeaderGroup } from '../header-group';
import { MenuServiceInt } from '@core/_services/menu.serviceint';
import { MessagesService } from '@core/_services/messages.service';
import { CommonService } from '@service/common.service';
import { ApiV6Service } from '@service/apiv6.service';
import { lastValueFrom } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-edit-group',
    templateUrl: './edit-group.component.html',
    styleUrls: ['./edit-group.component.scss'],
})
export class EditGroupComponent implements OnInit {
    public dataItem: HeaderGroup;
    public resultResult: any[];

    @Input()
    public item: any;

    @Input()
    public userListBase: any;

    @Input()
    public duplicate : boolean = false;

    @Output() 
    public onCancel: EventEmitter<any> = new EventEmitter();

    @Output()
    public onValidate: EventEmitter<any> = new EventEmitter();

    @Output()
    public onDeleteItem: EventEmitter<any> = new EventEmitter();
    
    @Output()
    public onLoadItem: EventEmitter<any> = new EventEmitter();


    constructor(
        private api: ApiV6Service,
        protected _messageService: MessagesService,
        public menu: MenuServiceInt,
        private commonService: CommonService,
        private translate: TranslateService
    ) {
        this.menu.display = true;
        this.dataItem = new HeaderGroup();
    }

    ngOnInit() {
        this.getData(this.item);
        this.commonService.checkReset();
    }

    private async getData(item) {
        let wRes: any;
        const wdata = { user: item.reference };
        try {
            wRes = await lastValueFrom(this.api.execUrlAction('getgroupdata', wdata ));
            this.dataItem.Clear();
            if (item.id !== 0) {
                this.dataItem.getUserList(wRes.GroupData.User.data);
                this.loadData(wRes.GroupData.Group.data[0], wRes.GroupData.User.data);
            }
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
        }
    }

    private loadData(adata, aDataGrp) {
        this.dataItem.duplicate = this.duplicate;
        this.dataItem.load(adata, aDataGrp);
        this.onLoadItem.emit({ index: this.item.index, id: this.item.id });
    }

    delete(data) {
        data.grpname = this.dataItem.grpname;
        this.onDeleteItem.emit({ index: this.item.index, id: this.item.id, data: data });
    }

    public async validate(data) {
        let wRes: any;
        if (this.dataItem.duplicate === true) {
            // id de la requête forcé à 0 : duplication
            data.id = 0;
            data.data.id = 0;
            data.data.autogenerated = false;
        } else {
            data.id = -1;
        }
        try {
            wRes = await lastValueFrom(this.api.execUrlAction('setgroupdata', data ));
            this.onValidate.emit({ index: this.item.index, id: this.item.id, data: wRes, duplicate: this.dataItem.duplicate });
        } catch (error) {
            if (error.error.Message === 'Exist') {
                this._messageService.addWarn(this.translate.instant('Cf_GroupExist', {group: data.data.grpname}));
            } else {
                console.log('Error', error);
                this._messageService.addErrorMsg(this.translate.instant('Update_KO'));
            }
        }
    }

    cancel(event) {
        this.onCancel.emit({ index: this.item.index, id: this.item.id });
    }
}
